import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_ACC_BU_NUDGE_REQUEST, fetchAccBuNudgeFailure, fetchAccBuNudgeSuccess, fetchAccBuNudgeVersionSuccess } from "../actions/accountBuNudgesActions";
import { fetchAccountBUNudges } from "../../../services/accIqService";

// Worker Saga
function* fetchAccBuNudgeDataSaga() {
  try {
    const payload = yield select(
      (state) => state?.accBuNudgeReducer?.payload
    );
    const { accountName, clientName, bu_unit } = payload;
    const data = yield call(
      fetchAccountBUNudges,
      accountName,
      clientName,
      bu_unit
    );
    const {result,version}= data;
    yield put(fetchAccBuNudgeSuccess(result));
    yield put(fetchAccBuNudgeVersionSuccess(version));
  } catch (error) {
    yield put(fetchAccBuNudgeFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchAccBuNudgeData() {
  yield takeLatest(FETCH_ACC_BU_NUDGE_REQUEST, fetchAccBuNudgeDataSaga);
}
